import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Box,
  Collapse,
  IconButton,
  Pagination,
  PaginationItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import { Key, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import ApiServices from "../../../service/apiService";
import Account from "../../../utils/apiConfig";
import { CourseUser, FetchAllUsers, UserCoursesModel } from "@mikros/library";
import ErrorHandler from "../../../utils/errorConfig";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "@mikros/shared-ui";
import { useNavigate } from "react-router-dom";
import { UserCoursesResponse } from "@mikros/library/src/model";

export interface UserCourseDataDupProps {
  // userDataCont: UserViewModel[];
  // userDataCont: UserCoursesModel;
  userDataCont: FetchAllUsers;
  userDataContFunction: Function;
  totalCount: number;
  totalCountFunction: Function;
  search: boolean;
  searchFunction: Function;
  formData: any;
  formDataFunction: Function;
  hasMoreData?: Boolean;
  hasMoreDataFunction: Function;
}
export function UserCourseDataDuplicate(props: UserCourseDataDupProps) {
  const theme = createTheme({
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
    },
  });
  const intl = useIntl();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalUsers, setTotalUsers] = useState<number>(0);
  const [lastKey, setLastKey] = useState<any>("");
  // const [hasMoreData, setHasMoreData] = useState(true); // Track if more data is available
  const [loading, setLoading] = useState(false);
  

  console.log("has more data check", props?.hasMoreData);

  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  console.log("error code flag value print", errorFlag);

  console.log("user data list", props?.userDataCont?.users);
  console.log("total users print", props.totalCount);

  type UserDataType = (typeof props.userDataCont.users)[number];

  const paginatedData = props.search
    ? rowsPerPage === -1
      ? props?.userDataCont.users // Display all records when rowsPerPage = -1
      : props?.userDataCont.users.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        ) // Frontend pagination
    : rowsPerPage === -1
    ? props?.userDataCont.users // API-based pagination
    : props?.userDataCont.users?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );

  console.log("paginated data", paginatedData);
  console.log("user model data print adfasasasffda", props.userDataCont);

  // Replace underscores with spaces
  const toTitleCase = (text: string) =>
    text
      ?.toLowerCase()
      ?.replace(/_/g, " ")
      ?.split(" ")
      ?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
      ?.join(" ");

  const totalPages =
    props?.userDataCont.users?.length > 0
      ? Math.ceil(props?.userDataCont.users?.length / rowsPerPage)
      : 1;

  // console.log("serwrwre aawer print total page", totalPages);
  console.log("last key print outside", lastKey);

  const handleChangePage = async (event: any, newPage: number) => {
    setPage(newPage - 1);
    console.log("click of handle change page");
    console.log("loading value in handle change page", loading);
    console.log("search value in handle change page", props.search);
    if (!loading && !props.search) {
      console.log("changing to page", newPage);

      console.log("last key print in handle change page", lastKey);
      console.log("print page", newPage, "last key", lastKey);

      fetchUsers(rowsPerPage, lastKey);
    }
  };

  const handleRowsPerPageChange = (event: { target: { value: string } }) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    console.log("Rows per page change value:", newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    if (!props.search) {
      props.formDataFunction({
        firstName: "",
        branchName: "",
        designation: "",
        location: "",
        department: "",
      });
      setPage(0);
      setLastKey(null);
      props.searchFunction(false);
      props.userDataContFunction({ users: [] });
      fetchUsers(newRowsPerPage, "");
    }
  };

  const dateFormatFunc = (dateString: string) => {
    if (!dateString) {
      return intl.formatMessage({ id: "naValue" });
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); //ensures 2  digit day
    const months = [
      intl.formatMessage({ id: "janValue" }),
      intl.formatMessage({ id: "febValue" }),
      intl.formatMessage({ id: "marValue" }),
      intl.formatMessage({ id: "aprValue" }),
      intl.formatMessage({ id: "mayValue" }),
      intl.formatMessage({ id: "junValue" }),
      intl.formatMessage({ id: "julValue" }),
      intl.formatMessage({ id: "augValue" }),
      intl.formatMessage({ id: "septValue" }),
      intl.formatMessage({ id: "octValue" }),
      intl.formatMessage({ id: "novValue" }),
      intl.formatMessage({ id: "decValue" }),
    ];
    const month = months[date.getMonth()]; // Get the month name

    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    //format time as hh:mm AM/PM (local time without seconds)
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm =
      hours >= 12
        ? intl.formatMessage({ id: "pmValue" })
        : intl.formatMessage({ id: "amValue" });
    hours = hours % 12; // to convert 24-format to 12-hour format
    hours = hours ? hours : 12; //to handle 0 hour
    const formattedTime = `${hours}:${minutes} ${ampm}`;
    return `${formattedDate} at ${formattedTime}`;
  };

  // function Row(props: { row: (typeof userModelData)[0] }) {
  function Row(props: { row: UserDataType }) {
    const { row } = props;
    const [open, setOpen] = useState(false);
    const [userCourseData, setUserCourseData] = useState<UserCoursesResponse>({
      courses: [],
    });
    const [loading, setLoading] = useState(false);
    const [dataFetched, setDataFetched] = useState(false);

    // Inner table sorting state and helpers (mirrors CourseViewDuplicate)
    const [innerSortField, setInnerSortField] = useState<string>("courseName");
    const [innerSortDir, setInnerSortDir] = useState<"asc" | "desc">("asc");

    const handleInnerSort = (field: string) => {
      if (innerSortField === field) {
        setInnerSortDir((prev) => (prev === "asc" ? "desc" : "asc"));
      } else {
        setInnerSortField(field);
        setInnerSortDir("asc");
      }
    };

    const getComparableValue = (detail: any, field: string) => {
      switch (field) {
        case "courseName":
          return (detail?.courseName || "").toString().toLowerCase();
        case "courseStatus":
          return (detail?.status || "").toString().toLowerCase();
        case "courseStartDate":
          return detail?.startDate ? new Date(detail.startDate).getTime() : Number.NEGATIVE_INFINITY;
        case "courseCompletionDate":
          return detail?.completedTime ? new Date(detail.completedTime).getTime() : Number.NEGATIVE_INFINITY;
        case "progressCompleted":
          return typeof detail?.userProgress === "number" ? detail.userProgress : Number.NEGATIVE_INFINITY;
        case "assessmentScore":
          // using courseScore in rendering; fall back if assessmentScore present
          return typeof detail?.courseScore === "number"
            ? detail.courseScore
            : (typeof detail?.assessmentScore === "number" ? detail.assessmentScore : Number.NEGATIVE_INFINITY);
        default:
          return "";
      }
    };

    const sortedCourses = [...(userCourseData.courses || [])].sort((a, b) => {
      const av = getComparableValue(a, innerSortField);
      const bv = getComparableValue(b, innerSortField);
      if (av < bv) return innerSortDir === "asc" ? -1 : 1;
      if (av > bv) return innerSortDir === "asc" ? 1 : -1;
      return 0;
    });

    const fetchUserCourseData = async () => {
      if (dataFetched) {
        return;
      }
      setLoading(true);
      try {
        const api = ApiServices.getInstance();
        const response = await api
          .makeRequest(
            `${accountInstance.accntId}/analytics/useranalytics?userId=${row.userId}`,
            "GET"
          )
          .then(async (response) => {
            if (response && response.errorMessage) {
              console.log("entered error code handling in user course data");
              setErrorFlag(true);
              await errorInstance.updateErrorCode(response.errorMessage);
              return;
            } else {
              setUserCourseData(response);
              setDataFetched(true); //mark data as fetched
            }
          });
      } catch (error) {
        console.error("error fetching audit data", error);
      } finally {
        setLoading(false);
      }
    };
    const handleExpandRow = () => {
      setOpen(!open);
      console.log("open value in handle expand row", open);
      if (!open) {
        fetchUserCourseData();
      }
    };
    console.log("open value", open);
    console.log("user course data", userCourseData);

    return (
      <>
        <TableRow
          sx={{
            "& > *": {
              borderBottom: open ? "none" : "1px solid rgba(223,224,224,1)",
            },
            backgroundColor: open
              ? "transparent"
              : "var(--color-mk-primary-20)",
            "&:hover": open
              ? {
                  backgroundColor: "#FFF !important", // Sets the background color to white on hover
                }
              : {},
          }}
        >
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              // onClick={() => setOpen(!open)}
              onClick={handleExpandRow}
              disableRipple
              disableFocusRipple
              style={{
                backgroundColor: "transparent", // Ensure no background color on hover
              }}
              sx={{
                "&:hover": {
                  backgroundColor: "transparent", // Prevent hover background color
                },
                "&:focus": {
                  backgroundColor: "transparent", // Prevent focus background color
                },
              }}
            >
              {open ? (
                <FontAwesomeIcon
                  icon={["fas", "fa-play" as IconName]}
                  className={`h-5 w-4.5 mx-3 hover:cursor-pointer text-mk-primary ${
                    open ? "rotate-90" : ""
                  }`}
                />
              ) : (
                <FontAwesomeIcon
                  icon={["fas", "fa-play" as IconName]}
                  className={`h-5 w-4.5 mx-3 hover:cursor-pointer text-mk-primary`}
                />
              )}
            </IconButton>
          </TableCell>
          <TableCell>
            {row?.userProfile?.firstName} {row?.userProfile?.lastName}
          </TableCell>
          <TableCell>{row.branchName}</TableCell>
          <TableCell>{row.department}</TableCell>
          <TableCell>{row.location}</TableCell>
          <TableCell>{row.designation}</TableCell>
          <TableCell>
            {/* {row.phoneNumber} */}
            {row.phNo}
          </TableCell>
          <TableCell>{row.email}</TableCell>
        </TableRow>

        <TableRow
          sx={{
            "& > *": {
              borderBottom: open ? "20px solid #F5F6FD !important" : "none",
              boxShadow: open ? "0px 4px 10px rgba(0,0,0,0.1)" : "none",
            },
            "&:hover": {
              backgroundColor: "#FFF !important", // Sets the background color to white on hover
            },
            marginBottom: open ? "16px" : "0",
            boxShadow: open ? "0px 4px 8px rgba(0, 0, 0, 0.1)" : "none", // Shadow effect when open
            padding: open ? "16px" : "0", // Optional padding inside the row when open
            borderRadius: open ? "8px" : "0", // Optional: rounded corners when ope
            zIndex: open ? 1 : "auto", // Brings the expanded row to the front
          }}
        >
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={2}>
                <Table
                  size="small"
                  aria-label="user details"
                  sx={{
                    "&:hover": {
                      backgroundColor: "#FFF !important", // Sets the background color to white on hover
                    },
                  }}
                >
                  <TableHead
                    sx={{
                      backgroundColor: "#FFF",
                      // "&:hover": {
                      //   backgroundColor: "transparent !important",
                      // },
                      "& .MuiTableRow-root:hover": {
                        background: "var(--color-mk-white) !important",
                      },
                      "&:hover": {
                        backgroundColor: "var(--color-mk-white) !important",
                      },
                    }}
                  >
                    <TableRow
                      sx={{
                        "&:hover": {
                          backgroundColor: "#FFF !important", // Sets the background color to white on hover
                        },
                      }}
                    >
                      <TableCell onClick={() => handleInnerSort("courseName")} sx={{ cursor: "pointer" }}>
                        <FormattedMessage id="analytics.userView.courseName" /> {innerSortField === "courseName" ? (innerSortDir === "asc" ? "▲" : "▼") : "↕"}
                      </TableCell>
                      <TableCell onClick={() => handleInnerSort("courseStatus")} sx={{ cursor: "pointer" }}>
                        <FormattedMessage id="analytics.userView.courseStatus" /> {innerSortField === "courseStatus" ? (innerSortDir === "asc" ? "▲" : "▼") : "↕"}
                      </TableCell>
                      <TableCell onClick={() => handleInnerSort("courseStartDate")} sx={{ cursor: "pointer" }}>
                        <FormattedMessage id="analytics.userView.courseStartDate" /> {innerSortField === "courseStartDate" ? (innerSortDir === "asc" ? "▲" : "▼") : "↕"}
                      </TableCell>

                      <TableCell onClick={() => handleInnerSort("courseCompletionDate")} sx={{ cursor: "pointer" }}>
                        <FormattedMessage id="analytics.userView.courseCompletionDate" /> {innerSortField === "courseCompletionDate" ? (innerSortDir === "asc" ? "▲" : "▼") : "↕"}
                      </TableCell>
                      <TableCell onClick={() => handleInnerSort("progressCompleted")} sx={{ cursor: "pointer" }}>
                        <FormattedMessage id="analytics.userView.progressCompleted" /> {innerSortField === "progressCompleted" ? (innerSortDir === "asc" ? "▲" : "▼") : "↕"} {"%"}
                      </TableCell>
                      <TableCell onClick={() => handleInnerSort("assessmentScore")} sx={{ cursor: "pointer" }}>
                        <FormattedMessage id="analytics.userView.assessmentScore" /> {innerSortField === "assessmentScore" ? (innerSortDir === "asc" ? "▲" : "▼") : "↕"} {"%"}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody
                    sx={{
                      "&:hover": {
                        backgroundColor: "#FFF !important", // Sets the background color to white on hover
                      },
                    }}
                  >
                    {/* {row.courses.length > 0 ? (
                      row.courses.map(
                        (detail: CourseUser, index: Key | null | undefined) => (
                          <TableRow
                            key={index}
                            sx={{
                              border: "none",
                              backgroundColor: "mk-white",
                              "&:hover": {
                                backgroundColor: "#FFF !important", // Sets the background color to white on hover
                              },
                            }}
                          >
                            <TableCell sx={{ border: "none" }}>
                              {detail.courseName}
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              {toTitleCase(detail.status)}
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              {dateFormatFunc(detail.startDate)}
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              {dateFormatFunc(detail.completedTime)}
                            </TableCell>

                            <TableCell sx={{ border: "none" }}>
                              {detail.userProgress}
                              {"%"}
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              {detail.courseScore}
                              {"%"}
                            </TableCell>
                          </TableRow>
                        )
                      )
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          // sx={{ textAlign: "center", border: "none" }

                          sx={{
                            textAlign: "center",
                            border: "none",
                            backgroundColor: "mk-white",
                            "&:hover": {
                              backgroundColor: "#FFF !important", // Sets the background color to white on hover
                            },
                          }}
                        >
                          <FormattedMessage id="analytics.userView.noCourse" />
                        </TableCell>
                      </TableRow>
                    )} */}

                    {sortedCourses.length > 0 ? (
                      sortedCourses.map((detail, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            border: "none",
                            backgroundColor: "mk-white",
                            "&:hover": {
                              backgroundColor: "#FFF !important", // Sets the background color to white on hover
                            },
                          }}
                        >
                          <TableCell sx={{ border: "none" }}>
                            {detail.courseName}
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            {toTitleCase(detail.status)}
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            {dateFormatFunc(detail.startDate)}
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            {detail.completedTime
                              ? dateFormatFunc(detail.completedTime)
                              : "N/A"}
                          </TableCell>

                          <TableCell sx={{ border: "none" }}>
                            {detail.userProgress}
                            {"%"}
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            {detail.courseScore
                              ? `${detail.courseScore}%`
                              : "N/A"}
                            {/* {"%"} */}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          // sx={{ textAlign: "center", border: "none" }

                          sx={{
                            textAlign: "center",
                            border: "none",
                            backgroundColor: "mk-white",
                            "&:hover": {
                              backgroundColor: "#FFF !important", // Sets the background color to white on hover
                            },
                          }}
                        >
                          <FormattedMessage id="analytics.userView.noCourse" />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  }

  // console.log("set user model data", userModelData);
  console.log("set user model data", props?.userDataCont);

  // function fetchUsers(limit: number, key: string) {
  //   let api = ApiServices.getInstance();

  //   if (limit === -1) {
  //     setLoading(true);
  //     console.log("inside limit equal -1 afdafaffffa");
  //     api
  //       .makeRequest(
  //         `${accountInstance.accntId}/analytics/useranalytics`,
  //         "GET"
  //       )
  //       .then(async (data) => {
  //         if (data && data.errorMessage) {
  //           console.log(
  //             "I entered error code handling in user course analytics"
  //           );
  //           setErrorFlag(true);
  //           await errorInstance.updateErrorCode(data.errorMessage);
  //           return;
  //         } else {
  //           props.userDataContFunction(data);
  //           const totalUserCount = data?.users?.length;
  //           props.totalCountFunction(totalUserCount);
  //           setLoading(false);
  //         }
  //       });
  //     return;
  //   }

  //   // if (accountInstance.accntId && key === undefined) {
  //   if (accountInstance.accntId && key === "") {
  //     setLoading(true);

  //     console.log("entered when last key is null");
  //     api
  //       .makeRequest(
  //         `${accountInstance.accntId}/analytics/useranalytics?limit=20`,
  //         "GET"
  //       )
  //       .then(async (data) => {
  //         if (data && data.errorMessage) {
  //           console.log(
  //             "I entered error code handling in user course analytics when last key is null"
  //           );
  //           setErrorFlag(true);
  //           await errorInstance.updateErrorCode(data.errorMessage);
  //           return;
  //         } else {
  //           props.userDataContFunction(data);
  //           const totalUserCount = data?.users?.length;
  //           props.totalCountFunction(totalUserCount);
  //           setLastKey(data.lastKey);
  //           // setHasMoreData(!!data.lastKey); // If lastKey exists, there's more data
  //           props.hasMoreDataFunction(!!data.lastKey);
  //           setLoading(false);
  //         }
  //       });
  //   }

  //   //need to check if correct// because duplicated maybe present
  //   else if (accountInstance.accntId && key !== null) {
  //     setLoading(true);
  //     console.log("Fetching next page with lastKey:", key);
  //     api
  //       .makeRequest(
  //         `${accountInstance.accntId}/analytics/useranalytics?limit=${limit}&lastKey=${key}`,
  //         "GET"
  //       )
  //       .then(async (data) => {
  //         if (data && data.errorMessage) {
  //           console.log(
  //             "I entered error code handling in user course analytics when last key is not null"
  //           );
  //           setErrorFlag(true);
  //           await errorInstance.updateErrorCode(data.errorMessage);
  //           return;
  //         } else {
  //           // Append only when paginating
  //           props?.userDataContFunction((prevData: any) => ({
  //             ...prevData,
  //             users: [...prevData?.users, ...data.users],
  //           }));
  //           props.totalCountFunction(
  //             (prevCount: any) => prevCount + (data?.users?.length || 0)
  //           );
  //           setLastKey(data.lastKey);
  //           // setHasMoreData(!!data.lastKey); // If lastKey exists, there's more data
  //           props.hasMoreDataFunction(!!data.lastKey);
  //           setLoading(false);
  //         }
  //       });
  //   }
  // }

  function fetchUsers(limit: number, key: string) {
    props.formDataFunction({
      designation: "", // Reset all fields to empty or their default value
      firstName: "",
      branchName: "",
      location: "",
      department: "",
    });
    let api = ApiServices.getInstance();
    if (limit === -1) {
      setLoading(true);
      console.log("inside limit equal -1");
      api
        .makeRequest(`${accountInstance.accntId}/user`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("entered error code handling in user details");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            props.userDataContFunction(data);
            const totalUserCount = data?.users?.length;
            props.totalCountFunction(totalUserCount);
            setLoading(false);
            // setFetchedDataBefore(true); // Prevent unnecessary re-fetching
            // props.hasMoreDataReference.current = !!data?.lastKey;

            if (props.hasMoreDataFunction) {
              props.hasMoreDataFunction(!!data.lastKey);
            }
          }
        });
      return;
    }
    if (accountInstance.accntId && key === "") {
      setLoading(true);

      console.log("entered when last key is null");
      api
        .makeRequest(`${accountInstance.accntId}/user?limit=20&reports=Y`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log(
              "I entered error code handling in user course analytics when last key is null"
            );
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            props.userDataContFunction(data);
            const totalUserCount = data?.users?.length;
            props.totalCountFunction(totalUserCount);
            setLastKey(data.lastKey);
            // props.hasMoreDataReference.current = !!data?.lastKey;
            console.log("data last key when limit 20", data?.lastKey);
            if (props.hasMoreDataFunction) {
              props.hasMoreDataFunction(!!data.lastKey);
            }
            setLoading(false);
            // setFetchedDataBefore(true); // Prevent unnecessary re-fetching
          }
        });
    }

    //need to check if correct// because duplicated maybe present
    else if (accountInstance.accntId && key !== null) {
      setLoading(true);
      console.log("Fetching next page with lastKey:", key);
      api
        .makeRequest(
          `${accountInstance.accntId}/user?limit=${limit}&lastKey=${key}`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log(
              "I entered error code handling in user course analytics when last key is not null"
            );
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data?.errorMessage);
            return;
          } else {
            // Append only when paginating
            props.userDataContFunction((prevData: any) => ({
              ...prevData,
              users: [...prevData?.users, ...data?.users],
            }));
            props.totalCountFunction(
              (prevCount: any) => prevCount + (data?.users?.length || 0)
            );
            setLastKey(data.lastKey);
            console.log("data last key when last key not null", data?.lastKey);

            // props.hasMoreDataReference.current = !!data?.lastKey;
            if (props.hasMoreDataFunction) {
              props.hasMoreDataFunction(!!data.lastKey);
            }
            setLoading(false);
            // setFetchedDataBefore(true); // Prevent unnecessary re-fetching
          }
        });
    }
  }

  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);

  useEffect(() => {
    fetchUsers(rowsPerPage, lastKey);
  }, [accountInstance.accntId]);

  useEffect(() => {
    if (page >= totalPages) {
      setPage(Math.max(totalPages - 1, 0));
    }
  }, [totalPages, page]);

  return (
    <div>
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                navigate("/home");
              } else {
                // navigate("/analytics");
                navigate("/reports");
              }
            }}
          />
        </Dialog>
      )}
      <TableContainer component={Paper} elevation={0}>
        <Table size="medium" aria-label="collapsible table">
          <TableHead>
            <TableRow
              sx={{
                "&:hover": {
                  backgroundColor: "#F5F6FD !important",
                },
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <TableCell
                sx={{
                  width: "3%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              />
              <TableCell
                sx={{
                  width: "16%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.userView.userName" />
              </TableCell>
              <TableCell
                sx={{
                  width: "16%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.userView.branch" />
              </TableCell>
              <TableCell
                sx={{
                  width: "16%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.userView.dept" />
              </TableCell>
              <TableCell
                sx={{
                  width: "16%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.userView.location" />
              </TableCell>
              <TableCell
                sx={{
                  width: "16%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.userView.desg" />
              </TableCell>
              <TableCell
                sx={{
                  width: "16%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.userView.phNo" />
              </TableCell>
              <TableCell
                sx={{
                  width: "17%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.userView.email" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.length > 0 ? (
              paginatedData?.map((row: any, index: Key | null | undefined) => (
                <Row key={index} row={row} />
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={15} align="center">
                  <div className="w-full h-full flex items-center justify-center text-center text-lg text-mk-primary-bright font-semibold mt-4">
                    <FormattedMessage id="users.addNewUser.noUser" />
                  </div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{
            backgroundColor: "#F5F6FD",
            padding: 0, // Removes padding
          }}
        >
          <Box display="flex" justifyContent="center" alignItems="center">
            <ThemeProvider theme={theme}>
              <Pagination
                count={totalPages}
                page={page + 1}
                onChange={handleChangePage}
                variant="text" //Removes border and background color
                shape="rounded"
                showFirstButton
                showLastButton
                siblingCount={1}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    disabled={
                      (item.type === "next" &&
                        // !hasMoreData &&
                        !props.hasMoreData &&
                        page === totalPages - 1) ||
                      ((item.type === "previous" || item.type === "first") &&
                        page === 0) ||
                      (item.type === "last" &&
                        // !hasMoreData &&
                        !props.hasMoreData &&
                        page === totalPages - 1)
                    }
                  />
                )}
              />
            </ThemeProvider>

            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                15,
                25,
                { label: intl.formatMessage({ id: "allValue" }), value: -1 },
              ]}
              component="div"
              // count={userModelData?.length}
              //   count={props?.userDataCont.users?.length}

              // count={totalUsers}
              count={props.totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={handleRowsPerPageChange}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} 
       
              ${intl.formatMessage({ id: "ofValue" })}
               ${count}
               ${intl.formatMessage({ id: "items" })}
                `
              }
              ActionsComponent={() => null} // to remove navigation buttons
              sx={{
                color: "#6464E5",
              }}
            />
          </Box>
        </Stack>
      </TableContainer>
    </div>
  );
}
